import React, { useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';
import Odometer from 'react-odometerjs';
import { useStelline } from '../contexts/StellineContext';
import { useResourceCelebration } from '../contexts/ResourceCelebrationContext';
import useResourceReceiveAnimation from '../hooks/useResourceReceiveAnimation';
import FaIcon from './FaIcon';
import styles from '../styles/StellineDisplay.module.css';
import 'odometer/themes/odometer-theme-default.css';

const StellineDisplay = ({ onClick }) => {
  const { isSignedIn } = useUser();
  const { stellineBalance, isLoading } = useStelline();
  const { registerTarget, targetImpactVersions, getPresentedCounterValue } = useResourceCelebration();
  const buttonRef = useRef(null);
  const displayBalance = isSignedIn ? getPresentedCounterValue('stelline', stellineBalance) : 0;
  const impactVersion = targetImpactVersions.stelline || 0;
  const isReceivingReward = useResourceReceiveAnimation(impactVersion);

  useEffect(() => {
    return registerTarget('stelline', buttonRef.current);
  }, [registerTarget]);

  return (
    <button
      ref={buttonRef}
      type="button"
      className={`${styles.stellineButton} ${isReceivingReward ? styles.receivingReward : ''}`}
      onClick={onClick}
      title="Le tue stelline"
      data-resource-target="stelline"
    >
      {isLoading ? (
        <span className={styles.loadingDots} />
      ) : (
        <Odometer
          value={displayBalance}
          format="(.ddd)"
          duration={500}
          className={styles.balance}
        />
      )}
      <span className={styles.icon} aria-hidden="true">
        <FaIcon className={`fa-solid fa-star ${styles.iconGlyph}`} />
      </span>
    </button>
  );
};

export default StellineDisplay;
